import { isReactNative } from './runtime';
export const request = () => {};
let PermissionsAndroid = {
  request: (auth, callback) => {},
  check: (auth) => {},
  PERMISSIONS: {}
};

if (isReactNative()) {
  PermissionsAndroid = require('react-native').PermissionsAndroid;
}
export default PermissionsAndroid;



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/PermissionsAndroid.js